/**
 * Choices for the "new placement" trigger (JT1-1907). The values are JobTetris's own, lowercase
 * (EmploymentType); the API matches them case-insensitively. There is no status choice: JobTetris
 * only sends live placements.
 */
export const EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'fixed_term', label: 'Fixed term' },
  { value: 'contract', label: 'Contract' },
];

/** Campaigns saved before JT1-1907 hold capitalised values ('PLACED'); map them onto the options. */
export function placementOptionValue(saved: string | null | undefined): string {
  return (saved ?? '').toLowerCase();
}
